import { render, staticRenderFns } from "./PlateFrequencyModal.vue?vue&type=template&id=7c3652d0&scoped=true"
import script from "./PlateFrequencyModal.vue?vue&type=script&lang=js"
export * from "./PlateFrequencyModal.vue?vue&type=script&lang=js"
import style0 from "./PlateFrequencyModal.vue?vue&type=style&index=0&id=7c3652d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3652d0",
  null
  
)

export default component.exports